import { useState } from 'react';
import useStateFromProps from '@/hooks/useStateFromProps';
import { Input } from 'antd';
import { useEffect } from 'react';
import { useRef } from 'react';
import EE from '@/common/event';
import { HelperCore } from "@/common/helper";
import { forwardRef, useImperativeHandle} from 'react';
import navbarStore from '@/store/navbar';
import modelChoiceStore from '@/components/model-choice/store.js';
import globalStore from '@/store/global';
import searchHomeStore from '@/pages/search-home/store'
import chatInputStore from '@/components/chat/ChatInput/store';

function ChatEditor(props, ref) {
  const {
    roleId,
    isAgent,
    className,
    style,
    maxLength,
    autoSize = false,
    onChange,
    onPressEnter,
    placeholder,
    handlePaste = () => {},
    onComposition,
    disabledInput,
  } = props;
  const $refInput = useRef(null);

  const [value, setValue] = useStateFromProps({ value: props.value || '' });
  const [isComposition, setComposition] = useState(false);

  const { frontIds } = modelChoiceStore;
  const currAsstId = roleId || frontIds?.[0];
  let modelName = '';
  if (currAsstId && !isAgent) {
    const modelInfo = navbarStore.chatModels[currAsstId];
    modelName = modelInfo?.home_recommend || modelInfo?.title;
  }

  const compositionRef = useRef(0)
  const handleInputChange = event => {
    const value = event.target.value;
    setValue(value);
    if (!isComposition) {
      onChange?.(value);
    }
    onComposition?.(compositionRef.current++)
  };

  const handleComposition = event => {
    if (event.type === 'compositionend') {
      setComposition(false);
      onChange?.(event.target.value);
    } else {
      setComposition(true);
    }
  };

  const handleFocus = () => {
    if(HelperCore.isPhone()) return;
    setTimeout(() => {
      $refInput.current?.focus({
        cursor : "end",
      });
    }, 20);
  }

  useImperativeHandle(ref, () => ({
    get value() {
      return $refInput?.current?.resizableTextArea.textArea;
    }
  }));

  useEffect(() => {
    if (maxLength > 0 && value.length > maxLength) {
      onChange?.(value.slice(0, maxLength));
    }
  }, [value, maxLength]);

  useEffect(() => {
    if($refInput.current){
      handleFocus();
      chatInputStore.setInputRef($refInput.current);
    }
  }, []);

  useEffect(() => {
    EE.on("chat_input_focus", handleFocus);

    return () => {
      EE.off("chat_input_focus", handleFocus);
    }
  }, []);

  let placeholderText = '';
  if (modelName) {
    placeholderText = `给${modelName}发送消息，Enter发送，Shift + Enter 换行`;
  }
  if (globalStore.isAiso() || !modelName) {
    placeholderText = `输入任何问题，Enter发送，Shift + Enter 换行`
    // 仅标准ai搜索、搜索首页可补充热词
    if (globalStore.isAisoHome() && !globalStore.is_super_aiso && searchHomeStore.recoWord) {
      placeholderText += ('，例如：' + searchHomeStore.recoWord)
    }
  }
  if (globalStore.is_super_aiso) {
    placeholderText = '输入任何问题，Enter发送，Shift + Enter 换行，自动分解并执行搜索任务'
  }

  return (
    <Input.TextArea
      ref={$refInput}
      className={['!text-16px !leading-24px !resize-none break-all overflow-x-hidden nw-scrollbar !transition-none', '!text-primary', className]}
      style={{...style}}
      autoFocus={HelperCore.isPhone() ? false : true}
      variant='borderless'
      maxLength={maxLength}
      autoSize={autoSize}
      placeholder={placeholder || placeholderText}
      value={value}
      disabled={disabledInput}
      onChange={handleInputChange}
      onPressEnter={event => {
        // Fix Chinese input method "Enter" on Safari
        if (event.keyCode == 229) return false;
        if (event.shiftKey || isComposition) {
          return;
        }
        event.preventDefault();
        onPressEnter?.(event);
      }}
      onPasteCapture={handlePaste}
      onCompositionUpdate={handleComposition}
      onCompositionEnd={handleComposition}
    />
  );
}

export default forwardRef(ChatEditor);
